import z from "zod";

export const BrandAmenitiesSchema = z.object({
  amenities: z.array(z.string()).refine(value => value.length > 0),
});

export type BrandAmenitiesType = z.infer<typeof BrandAmenitiesSchema>;
